import PropTypes from 'prop-types';
import { Provider, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, IconButton, Badge } from '@mui/material';
import {
    KeyboardArrowLeft,
    KeyboardArrowRight,
    Notifications
} from '@mui/icons-material';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import NameHeader from './nameHeader';
import { reducer } from 'store';

function Header({ handleLeftDrawerToggle, open }) {
    const theme = useTheme();
    const Icon = open ? KeyboardArrowLeft : KeyboardArrowRight;

    return (
        <Provider store={reducer}>
            <>
                {/*<Box
                    sx={{
                        display: 'flex',
                        [theme.breakpoints.down('md')]: {
                            width: 'auto'
                        }
                    }}
                >
                    <IconButton
                        edge="start"
                        color="#fff"
                        aria-label="menu"
                        onClick={handleLeftDrawerToggle}
                        sx={{
                            px: 0.5,
                            pt: 3,
                            backgroundColor: '#0A579B', //TODO - change this color to a theme palette
                            borderRadius: '0 0 4px 4px',
                            boxShadow: '0px 3px 6px #00000029',
                            '&:hover': {
                                backgroundColor: '#0A579B'
                            }
                        }}
                    >
                        <Icon
                            sx={{
                                fontSize: '38px', // Change the size
                                color: '#fff' // Change the color
                            }}
                        />
                    </IconButton>
                    <Box sx={{ width: 16 }}></Box>
                </Box>*/}
                <NameHeader />
                {/*<IconButton size="large" aria-label="show 17 new notifications">*/}
                {/*    <Badge badgeContent={17} color="error">*/}
                {/*        <Notifications sx={{ color: theme.palette.primary.main }} />*/}
                {/*    </Badge>*/}
                {/*</IconButton>*/}
                {/*<Box sx={{ width: 8 }}></Box>*/}
                {/*<NotificationSection />*/}
                <ProfileSection />
            </>
        </Provider>
    );
}

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func,
    open: PropTypes.bool
};

export default Header;
